import { Button, styled } from '@mui/material';

import type { StyledComponent } from '@emotion/styled';
import type { ComponentProps } from 'react';

export const StyledButton: StyledComponent<ComponentProps<typeof Button>> = styled(Button)(({ theme }) => ({
  margin: '0 1.5rem',
  // switch order with 2nd button
  ['&:first-of-type']: {
    order: 2,
  },
  // switch order with 1st button
  ['&:last-of-type']: {
    order: 1,
  },
  [theme.breakpoints.up('md')]: {
    margin: 0,

    // reset order
    ['&:first-of-type']: {
      order: 'unset',
    },
  },
}));
